import React from 'react';
import EnrichmentsScreen from './common/EnrichmentScreen';
import ButtonLink from '../../elements/ButtonLink';

export default class EnrichmentsHomeVoteLater extends React.Component {
    render() {
        let {i18n, event} = this.props;

        return <EnrichmentsScreen event={event} enrichmentCategory={this.props.category}>
            <div className="text main text-center" style={{
                    padding: '15vh 15px',
                    fontSize: '220%',
                    textDecoration: 'underline'
                }}>
                {i18n['label.no-vote-available']}
            </div>
            <ButtonLink href={['/events', event.id].join('/')} style={Object.assign({}, event._local.styles.button, {
                width: '80%', margin: '0 auto', fontSize: '150%',
            })}>{i18n['label.continue']}</ButtonLink>
        </EnrichmentsScreen>;
    }
}
